import { SET_FLOOR_DATA } from "../ActionName/ActionName"

export const setFloorJson = (data) => {
    return {
        type: SET_FLOOR_DATA,
        value: data
    }
}
